export default function autofocusDirective($timeout) {
	'ngInject';
	return {
		restrict: 'A',
		link: function ($scope, element, attrs) {
			$timeout(() => {
				try {
					element[0].focus();
				} catch (e) {}
			});
		},
	};
}
